const ta = {
  // ─── Common ───
  lang: 'ta',
  langLabel: 'தமிழ்',

  // ─── Free Kundli Page ───
  freeKundli: {
    title: 'இலவச ஜாதகம்',
    subtitle: 'தசா, யோகம், தோஷம் மற்றும் பஞ்சாங்கத்துடன் உங்கள் ஜாதகத்தை உருவாக்குங்கள்',
    enterBirthDetails: 'பிறப்பு விவரங்களை உள்ளிடுங்கள்',
    name: 'பெயர்',
    namePlaceholder: 'உங்கள் பெயரை உள்ளிடுங்கள்',
    gender: 'பாலினம்',
    male: 'ஆண்',
    female: 'பெண்',
    other: 'மற்றவை',
    dob: 'பிறந்த தேதி',
    tob: 'பிறந்த நேரம்',
    hour: 'மணி',
    minute: 'நிமிடம்',
    pob: 'பிறந்த இடம்',
    placePlaceholder: 'நகரத்தின் பெயரை தட்டச்சு செய்யுங்கள்...',
    ayanamsaSystem: 'அயனாம்ச முறை',
    includeAll: 'தசா, யோகம், தோஷம் & பஞ்சாங்கம் சேர்க்கவும்',
    generating: 'உருவாக்குகிறது...',
    generateKundli: 'ஜாதகம் உருவாக்கு',
    matchingLink: 'ஜாதக பொருத்தம் (குண மிலன்)',
    panchangamLink: 'இன்றைய பஞ்சாங்கம்',
    noChartTitle: 'ஜாதகம் இன்னும் உருவாக்கப்படவில்லை',
    noChartDesc: 'உங்கள் பிறப்பு விவரங்களை நிரப்பி "ஜாதகம் உருவாக்கு" பொத்தானை அழுத்தவும்',
    errSelectPlace: 'ஆயத்தொலைவுகளைப் பெற பரிந்துரைகளிலிருந்து ஒரு இடத்தைத் தேர்ந்தெடுக்கவும்.',
    errInvalidDob: 'சரியான பிறந்த தேதியை உள்ளிடவும்.',

    // Tabs
    tabChart: 'ராசி & கிரகங்கள்',
    tabDasha: 'தசா',
    tabYogas: 'யோகங்கள்',
    tabDoshas: 'தோஷங்கள்',
    tabPanchanga: 'பஞ்சாங்கம்',
    tabShadbala: 'ஷட்பலம்',
    tabAshtakavarga: 'அஷ்டகவர்க்கம்',
    tabVargas: 'வர்க்க ஜாதகங்கள்',
    tabHouses: 'பாவ பகுப்பாய்வு',
    tabBhavaBala: 'பாவ பலம்',
    tabVimshopaka: 'விம்சோபக',

    // Chart Tab
    rasiChakra: 'ராசி சக்கரம்',
    navamsaChakra: 'நவாம்ச சக்கரம்',
    planetDetails: 'கிரக விவரங்கள்',
    colPlanet: 'கிரகம்',
    colSign: 'ராசி',
    colDegree: 'பாகை',
    colNakshatra: 'நட்சத்திரம்',
    colPada: 'பாதம்',
    colNavamsa: 'நவாம்சம்',
    colRetro: 'வக்ரம்',
    birthDetails: 'பிறப்பு விவரங்கள்',
    labelName: 'பெயர்',
    labelGender: 'பாலினம்',
    labelDate: 'தேதி',
    labelTime: 'நேரம்',
    labelPlace: 'இடம்',
    labelAyanamsa: 'அயனாம்சம்',

    // Dasha Tab
    vimshottariDasha: 'விம்சோத்தரி தசா',
    currentlyRunning: 'தற்போது நடப்பில் உள்ளது',
    mahadasha: 'மகா தசா',
    antardasha: 'அந்தர தசா',
    pratyantdasha: 'பிரத்யந்தர தசா',
    birthDashaLord: 'பிறப்பு தசா நாதன்',
    balanceAtBirth: 'பிறப்பில் மீதம்',
    moonNakshatra: 'சந்திர நட்சத்திரம்',
    yrs: 'வருடங்கள்',
    years: 'வருடங்கள்',
    yrsUnit: 'வ',
    monthsUnit: 'மா',
    daysUnit: 'நா',
    mahadashaPeriods: 'மகா தசா காலங்கள்',
    bukthi: 'புக்தி',
    anthara: 'அந்தரம்',
    sukshuma: 'சூக்ஷ்மம்',
    prana: 'பிராணன்',
    dashaClickHint: 'மகா தசாவை கிளிக் செய்து புக்தி காலங்களைக் காண',
    clickForAnthara: 'அந்தர காலங்களைக் காண கிளிக் செய்யவும்',
    clickForSukshuma: 'சூக்ஷ்ம காலங்களைக் காண கிளிக் செய்யவும்',
    clickForPrana: 'பிராண காலங்களைக் காண கிளிக் செய்யவும்',

    // Yogas Tab
    yogasFound: 'கண்டறியப்பட்ட யோகங்கள்',
    noYogas: 'இந்த ஜாதகத்தில் குறிப்பிடத்தக்க யோகங்கள் காணப்படவில்லை.',

    // Doshas Tab
    doshaAnalysis: 'தோஷ பகுப்பாய்வு',
    present: 'உள்ளது',
    notPresent: 'இல்லை',
    cancellations: 'பரிகாரங்கள் (நிவர்த்தி)',
    remedies: 'பரிகாரங்கள்',

    // Panchanga Tab
    panchangaTitle: 'பஞ்சாங்கம் (ஐந்து அங்கங்கள்)',
    tithi: 'திதி',
    vara: 'வாரம்',
    nakshatra: 'நட்சத்திரம்',
    yoga: 'யோகம்',
    karana: 'கரணம்',
    paksha: 'பக்ஷம்',
    lord: 'அதிபதி',
  },

  // ─── Kundli Matching Page ───
  matching: {
    backToKundli: 'ஜாதகத்திற்கு திரும்பு',
    title: 'ஜாதக பொருத்தம்',
    subtitle: 'அஷ்டகூட குண மிலன் - திருமண பொருத்த பகுப்பாய்வு',
    brideDetails: 'பெண் பிறப்பு விவரங்கள்',
    groomDetails: 'ஆண் பிறப்பு விவரங்கள்',
    dob: 'பிறந்த தேதி',
    tob: 'பிறந்த நேரம்',
    hour: 'மணி',
    minute: 'நிமிடம்',
    pob: 'பிறந்த இடம்',
    placePlaceholder: 'நகரத்தை தட்டச்சு செய்யுங்கள்...',
    calculating: 'பொருத்தம் கணக்கிடுகிறது...',
    calculateMatching: 'பொருத்தம் கணக்கிடு',
    errSelectPlace: 'பெண் மற்றும் ஆண் இருவருக்கும் பரிந்துரைகளிலிருந்து இடத்தைத் தேர்ந்தெடுக்கவும்.',
    errInvalidDob: 'சரியான பிறந்த தேதிகளை உள்ளிடவும்.',

    // Results
    kootaBreakdown: 'கூட பிரிவு',
    mangalCrossCheck: 'செவ்வாய் தோஷ பரிசோதனை',
    bride: 'பெண்',
    groom: 'ஆண்',
    manglik: 'செவ்வாய் தோஷம் உள்ளது',
    nonManglik: 'செவ்வாய் தோஷம் இல்லை',
    compatible: 'பொருத்தம்',
    mismatch: 'பொருத்தமின்மை (பரிகாரங்களுக்கு ஜோதிடரை அணுகவும்)',
    recommendations: 'பரிந்துரைகள்',
    brideChart: 'பெண் ஜாதகம்',
    groomChart: 'ஆண் ஜாதகம்',
  },

  // ─── Koota Names & Descriptions ───
  kootaNames: {
    Varna: 'வர்ணம்',
    Vashya: 'வஷ்யம்',
    Tara: 'தாரா',
    Yoni: 'யோனி',
    'Graha Maitri': 'கிரக மைத்ரி',
    Gana: 'கணம்',
    Bhakoot: 'பகூடம்',
    Nadi: 'நாடி',
  },
  kootas: {
    Varna: 'ஆன்மீக பொருத்தம் & அகங்கார நிலைகள்',
    Vashya: 'பரஸ்பர ஈர்ப்பு & ஆதிக்கம்',
    Tara: 'ஆரோக்கியம் மற்றும் விதி பொருத்தம்',
    Yoni: 'உடல் மற்றும் பாலியல் பொருத்தம்',
    'Graha Maitri': 'மன & அறிவுசார் பொருத்தம்',
    Gana: 'குணம் மற்றும் இயல்பு பொருத்தம்',
    Bhakoot: 'உணர்ச்சி மற்றும் நிதி பொருத்தம்',
    Nadi: 'ஆரோக்கியம், மரபணு & சந்ததி பொருத்தம்',
  },
  // ─── Matching Verdicts ───
  verdicts: {
    'Excellent': 'மிகச்சிறப்பு',
    'Very Good': 'மிக நல்லது',
    'Good': 'நல்லது',
    'Average': 'சராசரி',
    'Below Average': 'சராசரிக்கு கீழ்',
    'Not Recommended': 'பரிந்துரைக்கப்படவில்லை',
  },
  // ─── Matching Recommendations (common phrases) ───
  matchingRecommendations: {
    'Excellent match! Highly compatible couple.': 'மிகச்சிறந்த பொருத்தம்! மிகவும் இணக்கமான ஜோடி.',
    'Very good compatibility. Marriage is recommended.': 'மிக நல்ல பொருத்தம். திருமணம் பரிந்துரைக்கப்படுகிறது.',
    'Good compatibility with minor areas of adjustment.': 'சிறிய சரிசெய்தல்களுடன் நல்ல பொருத்தம்.',
    'Average compatibility. Consult an astrologer for detailed analysis.': 'சராசரி பொருத்தம். விரிவான பகுப்பாய்வுக்கு ஜோதிடரை அணுகவும்.',
    'Below average compatibility. Remedial measures may be needed.': 'சராசரிக்கு கீழ் பொருத்தம். பரிகாரங்கள் தேவைப்படலாம்.',
    'Nadi Dosha detected. Special remedies recommended.': 'நாடி தோஷம் கண்டறியப்பட்டது. சிறப்பு பரிகாரங்கள் பரிந்துரைக்கப்படுகின்றன.',
    'Bhakoot Dosha present. May affect health and finances.': 'பகூட தோஷம் உள்ளது. ஆரோக்கியம் மற்றும் நிதியை பாதிக்கலாம்.',
    'Both partners have matching Mangal status — no issues.': 'இரு பங்காளிகளுக்கும் ஒத்த செவ்வாய் நிலை — பிரச்சனை இல்லை.',
    'Mangal Dosha mismatch — consult astrologer for cancellation conditions.': 'செவ்வாய் தோஷ பொருத்தமின்மை — நிவர்த்தி நிலைமைகளுக்கு ஜோதிடரை அணுகவும்.',
  },

  // ─── Planet Names ───
  planets: {
    Ascendant: 'லக்னம்',
    Sun: 'சூரியன்',
    Moon: 'சந்திரன்',
    Mars: 'செவ்வாய்',
    Mercury: 'புதன்',
    Jupiter: 'குரு',
    Venus: 'சுக்கிரன்',
    Saturn: 'சனி',
    Rahu: 'ராகு',
    Ketu: 'கேது',
  },

  // ─── Sign Names ───
  signs: {
    Aries: 'மேஷம்',
    Taurus: 'ரிஷபம்',
    Gemini: 'மிதுனம்',
    Cancer: 'கடகம்',
    Leo: 'சிம்மம்',
    Virgo: 'கன்னி',
    Libra: 'துலாம்',
    Scorpio: 'விருச்சிகம்',
    Sagittarius: 'தனுசு',
    Capricorn: 'மகரம்',
    Aquarius: 'கும்பம்',
    Pisces: 'மீனம்',
  },

  // ─── Nakshatra Names ───
  nakshatras: {
    'Ashwini': 'அஸ்வினி',
    'Bharani': 'பரணி',
    'Krittika': 'கிருத்திகை',
    'Rohini': 'ரோகிணி',
    'Mrigashira': 'மிருகசீரிடம்',
    'Ardra': 'திருவாதிரை',
    'Punarvasu': 'புனர்பூசம்',
    'Pushya': 'பூசம்',
    'Ashlesha': 'ஆயில்யம்',
    'Magha': 'மகம்',
    'Purva Phalguni': 'பூரம்',
    'Uttara Phalguni': 'உத்திரம்',
    'Hasta': 'ஹஸ்தம்',
    'Chitra': 'சித்திரை',
    'Swati': 'சுவாதி',
    'Vishakha': 'விசாகம்',
    'Anuradha': 'அனுஷம்',
    'Jyeshtha': 'கேட்டை',
    'Moola': 'மூலம்',
    'Purva Ashadha': 'பூராடம்',
    'Uttara Ashadha': 'உத்திராடம்',
    'Shravana': 'திருவோணம்',
    'Dhanishta': 'அவிட்டம்',
    'Shatabhisha': 'சதயம்',
    'Purva Bhadrapada': 'பூரட்டாதி',
    'Uttara Bhadrapada': 'உத்திரட்டாதி',
    'Revati': 'ரேவதி',
  },

  // ─── Sign Abbreviations (for chart cells) ───
  signAbbrevs: ['மேஷ', 'ரிஷ', 'மிது', 'கடக', 'சிம்', 'கன்', 'துலா', 'விரு', 'தனு', 'மகர', 'கும்', 'மீன'],

  // ─── Ascendant abbreviation ───
  ascAbbrev: 'லக்',

  // ─── Yoga Names ───
  yogaNames: {
    'Gajakesari Yoga': 'கஜகேசரி யோகம்',
    'Budhaditya Yoga': 'புதாதித்ய யோகம்',
    'Ruchaka Yoga': 'ருசக யோகம்',
    'Bhadra Yoga': 'பத்ர யோகம்',
    'Hamsa Yoga': 'ஹம்ச யோகம்',
    'Malavya Yoga': 'மாளவ்ய யோகம்',
    'Sasa Yoga': 'சச யோகம்',
    'Adhi Yoga': 'அதி யோகம்',
    'Chandra-Mangal Yoga': 'சந்திர-செவ்வாய் யோகம்',
    'Sunapha Yoga': 'சுனபா யோகம்',
    'Anapha Yoga': 'அனபா யோகம்',
    'Durudhara Yoga': 'துருதுரா யோகம்',
    'Kemadruma Yoga': 'கேமத்ருமா யோகம்',
    'Dhana Yoga': 'தன யோகம்',
    'Raja Yoga': 'ராஜ யோகம்',
    'Viparita Raja Yoga': 'விபரீத ராஜ யோகம்',
    'Neechabhanga Raja Yoga': 'நீசபங்க ராஜ யோகம்',
    'Lakshmi Yoga': 'லக்ஷ்மி யோகம்',
    'Saraswati Yoga': 'சரஸ்வதி யோகம்',
    'Amala Yoga': 'அமல யோகம்',
  },

  // ─── Yoga Sanskrit (Tamil script) ───
  yogaSanskrit: {
    'Gajakesari Yoga': 'கஜகேசரி யோகம்',
    'Budhaditya Yoga': 'புதாதித்ய யோகம்',
    'Ruchaka Yoga': 'ருசக யோகம்',
    'Bhadra Yoga': 'பத்ர யோகம்',
    'Hamsa Yoga': 'ஹம்ச யோகம்',
    'Malavya Yoga': 'மாளவ்ய யோகம்',
    'Sasa Yoga': 'சச யோகம்',
    'Adhi Yoga': 'அதி யோகம்',
    'Chandra-Mangal Yoga': 'சந்திர-செவ்வாய் யோகம்',
    'Sunapha Yoga': 'சுனபா யோகம்',
    'Anapha Yoga': 'அனபா யோகம்',
    'Durudhara Yoga': 'துருதுரா யோகம்',
    'Kemadruma Yoga': 'கேமத்ருமா யோகம்',
    'Dhana Yoga': 'தன யோகம்',
    'Raja Yoga': 'ராஜ யோகம்',
    'Viparita Raja Yoga': 'விபரீத ராஜ யோகம்',
    'Neechabhanga Raja Yoga': 'நீசபங்க ராஜ யோகம்',
    'Lakshmi Yoga': 'லக்ஷ்மி யோகம்',
    'Saraswati Yoga': 'சரஸ்வதி யோகம்',
    'Amala Yoga': 'அமல யோகம்',
  },

  // ─── Yoga Descriptions ───
  yogaDescriptions: {
    'Gajakesari Yoga': 'சந்திரனிலிருந்து கேந்திரத்தில் குரு — ஞானம், புகழ், நிலையான செழிப்பு',
    'Budhaditya Yoga': 'சூரிய-புதன் சேர்க்கை — அறிவு, சொல்வன்மை, பகுப்பாய்வு திறன்',
    'Ruchaka Yoga': 'கேந்திரத்தில் செவ்வாய் சொந்த/உச்ச ராசியில் — வீரம், தலைமை, உடல் வலிமை',
    'Bhadra Yoga': 'கேந்திரத்தில் புதன் சொந்த/உச்ச ராசியில் — அறிவு, வணிக திறன், தொடர்பாடல்',
    'Hamsa Yoga': 'கேந்திரத்தில் குரு சொந்த/உச்ச ராசியில் — ஆன்மீகம், ஞானம், நற்பண்பு',
    'Malavya Yoga': 'கேந்திரத்தில் சுக்கிரன் சொந்த/உச்ச ராசியில் — கலை, அழகு, ஆடம்பரம்',
    'Sasa Yoga': 'கேந்திரத்தில் சனி சொந்த/உச்ச ராசியில் — அதிகாரம், ஒழுக்கம், அரசியல் சக்தி',
    'Adhi Yoga': 'சந்திரனிலிருந்து 6/7/8-ல் சுபக்கிரகங்கள் — தலைமை மற்றும் செழிப்பு',
    'Chandra-Mangal Yoga': 'சந்திர-செவ்வாய் சேர்க்கை — சம்பாதிக்கும் திறன், சொந்த முயற்சியில் செல்வம்',
    'Sunapha Yoga': 'சந்திரனிலிருந்து 2-ல் கிரகம் — சுயமாக உருவாக்கிய செல்வம் மற்றும் அறிவு',
    'Anapha Yoga': 'சந்திரனிலிருந்து 12-ல் கிரகம் — ஆன்மீக நாட்டம் மற்றும் நல்ல ஆரோக்கியம்',
    'Durudhara Yoga': 'சந்திரனின் இருபுறமும் கிரகங்கள் (2 மற்றும் 12) — செல்வம், புகழ், தாராள குணம்',
    'Kemadruma Yoga': 'சந்திரனுக்கு அருகில் கிரகங்கள் இல்லை — போராட்டம் மற்றும் தனிமை காலங்கள் (நிவர்த்திகளை சரிபாருங்கள்)',
    'Dhana Yoga': '2 மற்றும் 11-ம் அதிபதிகள் வலிமையான நிலையில் — செல்வக் குவிப்பு',
    'Raja Yoga': 'கேந்திர அதிபதி திரிகோண அதிபதியுடன் சேர்க்கை — அதிகாரம், பதவி, தலைமை',
    'Viparita Raja Yoga': 'துஸ்தான அதிபதிகள் துஸ்தான வீடுகளில் — துன்பத்தின் மூலம் வெற்றி, எதிர்பாராத லாபம்',
    'Neechabhanga Raja Yoga': 'நீச கிரகம் கேந்திரத்தில் நிவர்த்தி — ஆரம்ப சவால்களுக்குப் பிறகு உயர்வு',
    'Lakshmi Yoga': '9-ம் அதிபதி சொந்த/உச்ச ராசியில் கேந்திரத்தில் — தெய்வீக அதிர்ஷ்டம் மற்றும் செழிப்பு',
    'Saraswati Yoga': 'குரு, சுக்கிரன், புதன் கேந்திர/திரிகோண/2-ல் — அசாதாரண கல்வி, கலை, ஞானம்',
    'Amala Yoga': '10-ம் வீட்டில் சுபக்கிரகம் — தூய குணம், நற்செயல்கள், நிலையான புகழ்',
  },

  // ─── Yoga Strength ───
  yogaStrength: {
    'very strong': 'மிகவும் வலிமை',
    'strong': 'வலிமை',
    'moderate': 'நடுத்தரம்',
    'weak': 'பலவீனம்',
  },

  // ─── Dosha Names ───
  doshaNames: {
    'Mangal Dosha': 'செவ்வாய் தோஷம்',
    'Kaal Sarp Dosha': 'கால சர்ப்ப தோஷம்',
    'Pitru Dosha': 'பித்ரு தோஷம்',
    'Sade Sati': 'ஏழரை சனி',
    'Gandanta': 'கண்டாந்தம்',
  },

  // ─── Dosha Descriptions ───
  doshaDescriptions: {
    'Mars is not in dosha-causing houses — no Mangal Dosha': 'செவ்வாய் தோஷம் தரும் வீடுகளில் இல்லை — செவ்வாய் தோஷம் இல்லை',
    'All 7 planets are hemmed between Rahu-Ketu axis — intense karmic pattern': 'அனைத்து 7 கிரகங்களும் ராகு-கேது அச்சுக்கு இடையில் — தீவிர கர்ம அமைப்பு',
    'Planets are distributed on both sides of Rahu-Ketu axis — no Kaal Sarp Dosha': 'கிரகங்கள் ராகு-கேது அச்சின் இருபுறமும் பரவியுள்ளன — கால சர்ப்ப தோஷம் இல்லை',
    'No Pitru Dosha conditions found': 'பித்ரு தோஷ நிலைகள் காணப்படவில்லை',
    'Saturn transiting over Moon sign (peak phase) — emotional challenges, transformation': 'சனி சந்திர ராசி மீது பெயர்ச்சி (உச்ச நிலை) — உணர்ச்சி சவால்கள், மாற்றம்',
    'Saturn in 12th from Moon (rising phase of Sade Sati) — beginning of challenges': 'சந்திரனிலிருந்து 12-ல் சனி (ஏழரை சனி ஆரம்பம்) — சவால்களின் தொடக்கம்',
    'Saturn in 2nd from Moon (setting phase of Sade Sati) — challenges easing': 'சந்திரனிலிருந்து 2-ல் சனி (ஏழரை சனி முடிவு) — சவால்கள் குறைகின்றன',
    'Saturn is not near Moon sign — no Sade Sati currently': 'சனி சந்திர ராசிக்கு அருகில் இல்லை — தற்போது ஏழரை சனி இல்லை',
    'No planets in Gandanta zones': 'கண்டாந்த மண்டலங்களில் கிரகங்கள் இல்லை',
  },

  // ─── Dosha Severity ───
  doshaSeverity: {
    'high': 'அதிகம்',
    'medium': 'நடுத்தரம்',
    'low': 'குறைவு',
    'cancelled': 'நிவர்த்தி',
    'none': 'இல்லை',
  },

  // ─── Dosha Remedies ───
  doshaRemedies: {
    'Recite Hanuman Chalisa on Tuesdays': 'செவ்வாய்க்கிழமை அனுமன் சாலிசா படிக்கவும்',
    'Donate red lentils (masoor dal) on Tuesdays': 'செவ்வாய்க்கிழமை சிவப்பு பருப்பு தானம் செய்யவும்',
    'Wear red coral (Moonga) gemstone after consultation': 'ஆலோசனைக்குப் பிறகு பவளம் (மூங்கா) அணியவும்',
    'Perform Mangal Shanti Puja': 'செவ்வாய் சாந்தி பூஜை செய்யவும்',
    'Recite Shani Mantra on Saturdays': 'சனிக்கிழமை சனி மந்திரம் ஜபிக்கவும்',
    'Practice patience and discipline': 'பொறுமை மற்றும் ஒழுக்கத்தை கடைபிடிக்கவும்',
    'Perform Gandanta Dosha Shanti Puja': 'கண்டாந்த தோஷ சாந்தி பூஜை செய்யவும்',
    'Donate to charity on the planet\'s day': 'கிரகத்தின் நாளில் தானம் செய்யவும்',
    'Recite Navagraha Mantra daily': 'தினமும் நவகிரக மந்திரம் ஜபிக்கவும்',
    'Perform Pitru Tarpana on Amavasya': 'அமாவாசையில் பித்ரு தர்ப்பணம் செய்யவும்',
    'Visit Rahu-Ketu temple on appropriate days': 'உரிய நாட்களில் ராகு-கேது கோயிலுக்கு செல்லவும்',
    'Perform Kaal Sarp Dosha Puja at Trimbakeshwar': 'திரிம்பகேஷ்வரில் கால சர்ப்ப தோஷ பூஜை செய்யவும்',
  },

  // ─── Panchanga: Tithi Names ───
  tithiNames: {
    'Pratipada': 'பிரதமை',
    'Dwitiya': 'துவிதியை',
    'Tritiya': 'திருதியை',
    'Chaturthi': 'சதுர்த்தி',
    'Panchami': 'பஞ்சமி',
    'Shashthi': 'சஷ்டி',
    'Saptami': 'சப்தமி',
    'Ashtami': 'அஷ்டமி',
    'Navami': 'நவமி',
    'Dashami': 'தசமி',
    'Ekadashi': 'ஏகாதசி',
    'Dwadashi': 'துவாதசி',
    'Trayodashi': 'திரயோதசி',
    'Chaturdashi': 'சதுர்தசி',
    'Purnima': 'பௌர்ணமி',
    'Amavasya': 'அமாவாசை',
  },

  // ─── Panchanga: Paksha ───
  pakshaNames: {
    'Shukla': 'சுக்ல',
    'Krishna': 'கிருஷ்ண',
  },

  // ─── Panchanga: Vara (Day) Names ───
  varaNames: {
    'Sunday': 'ஞாயிறு',
    'Monday': 'திங்கள்',
    'Tuesday': 'செவ்வாய்',
    'Wednesday': 'புதன்',
    'Thursday': 'வியாழன்',
    'Friday': 'வெள்ளி',
    'Saturday': 'சனி',
  },

  // ─── Panchanga: Yoga Names (27 yogas) ───
  panchangaYogaNames: {
    'Vishkumbha': 'விஷ்கும்பம்',
    'Preeti': 'பிரீதி',
    'Ayushman': 'ஆயுஷ்மான்',
    'Saubhagya': 'சௌபாக்யம்',
    'Shobhana': 'சோபனம்',
    'Atiganda': 'அதிகண்டம்',
    'Sukarma': 'சுகர்மா',
    'Dhriti': 'த்ருதி',
    'Shoola': 'சூலம்',
    'Ganda': 'கண்டம்',
    'Vriddhi': 'விருத்தி',
    'Dhruva': 'த்ருவம்',
    'Vyaghata': 'வியாகாதம்',
    'Harshana': 'ஹர்ஷணம்',
    'Vajra': 'வஜ்ரம்',
    'Siddhi': 'சித்தி',
    'Vyatipata': 'வியதீபாதம்',
    'Variyana': 'வரீயான்',
    'Parigha': 'பரிகம்',
    'Shiva': 'சிவம்',
    'Siddha': 'சித்தம்',
    'Sadhya': 'சாத்யம்',
    'Shubha': 'சுபம்',
    'Shukla': 'சுக்லம்',
    'Brahma': 'பிரம்மம்',
    'Indra': 'இந்திரம்',
    'Vaidhriti': 'வைத்ருதி',
  },

  // ─── Panchanga: Karana Names ───
  karanaNames: {
    'Bava': 'பவம்',
    'Balava': 'பாலவம்',
    'Kaulava': 'கௌலவம்',
    'Taitila': 'தைதிலம்',
    'Gara': 'கரம்',
    'Vanija': 'வணிஜம்',
    'Vishti': 'விஷ்டி',
    'Shakuni': 'சகுனி',
    'Chatushpada': 'சதுஷ்பாதம்',
    'Naga': 'நாகம்',
    'Kimstughna': 'கிம்ஸ்துக்னம்',
  },

  // ─── Daily Balance (KalaShakti) ───
  dailyBalanceTitle: 'கலாசக்தி தினசரி சமநிலை',
  dailyBalanceSubtitle: 'அஷ்டகவர்க்கத்தை அடிப்படையாகக் கொண்ட உங்கள் தனிப்பயன் தினசரி கிரக பலம்',
  computeBalance: 'தினசரி சமநிலை கணக்கிடுக',
  computing: 'கணக்கிடுகிறது...',
  whatIsKalaShakti: 'கலாசக்தி என்றால் என்ன?',
  kalaShaktiDesc: 'கலாசக்தி தினசரி சமநிலை உங்கள் ஜாதகத்தின் அஷ்டகவர்க்க தரவுகளையும் தற்போதைய கோள் பெயர்ச்சிகளையும் இணைத்து உங்களுக்கான தனிப்பயன் தினசரி மதிப்பெண் (0-100) தருகிறது.',
  scoreComponents: 'மதிப்பெண் கூறுகள்',
  tabHighlights: 'முக்கியக் குறிப்புகள்',
  tabPlanets: 'கிரக அறிக்கைகள்',
  tabSky: 'தற்போதைய வானம்',
  tabHourly: 'மணிநேர நேரவரிசை',
  strength: 'வலிமை',
  caution: 'எச்சரிக்கை',
  lifeArea: 'வாழ்க்கைத் துறை',
  transitSign: 'பெயர்ச்சி ராசி',
  kakshya: 'கக்ஷ்யை',
  house: 'பாவம்',
  currentSky: 'தற்போதைய வானம்',
  hourlyTimeline: 'மணிநேர நேரவரிசை',
  bestWindow: 'சிறந்த நேரம்',
  newChart: 'புதிய வரைபடம்',
  targetDate: 'தேதி',

  // ─── Vedic Shared Forms ───
  vedic: {
    forms: {
      name: 'பெயர்',
      namePlaceholder: 'பெயரை உள்ளிடவும்',
      gender: 'பாலினம்',
      male: 'ஆண்',
      female: 'பெண்',
      dob: 'பிறந்த தேதி',
      tob: 'பிறந்த நேரம்',
      hour: 'மணி',
      minute: 'நிமிடம்',
      am: 'காலை',
      pm: 'மாலை',
      timeFormat: 'நேர வடிவம்',
      format12h: '12 மணி',
      format24h: '24 மணி',
      place: 'பிறந்த இடம்',
      placePlaceholder: 'இடத்தின் பெயரைத் தட்டச்சு செய்யவும்...',
      locationLabel: 'இடம்',
      ayanamsa: 'அயனாம்ச முறை',
      date: 'தேதி',
      generate: 'உருவாக்கு',
      compute: 'கணக்கிடு',
      calculate: 'கணக்கிடு',
      loading: 'கணக்கிடுகிறது...',
      submit: 'சமர்ப்பி',
      errSelectPlace: 'பரிந்துரைகளிலிருந்து ஒரு இடத்தைத் தேர்ந்தெடுக்கவும்',
      errInvalidDob: 'சரியான பிறந்த தேதியை உள்ளிடவும்',
      errInvalidTime: 'சரியான நேரத்தை உள்ளிடவும்',
      timezone: 'நேர மண்டலம்',
      detecting: 'நேர மண்டலம் கண்டறியப்படுகிறது...',
      useRecentData: 'உங்கள் கடந்த அமர்வின் பிறப்பு தரவு கிடைக்கிறது.',
      useIt: 'பயன்படுத்து',
      dismiss: 'நிராகரி',
      chartStyle: 'சார்ட் வகை',
      southIndian: 'தென்னிந்திய',
      northIndian: 'வடஇந்திய',
    },
  },

  // ─── Panchangam Page ───
  panchangam: {
    pageTitle: 'இன்றைய பஞ்சாங்கம்',
    pageSubtitle: 'நேரங்கள் மற்றும் சுப காலங்களுடன் தினசரி பஞ்சாங்கம்',
    sections: {
      fiveLimbs: 'பஞ்ச அங்கம் (ஐந்து உறுப்புகள்)',
      sunMoon: 'சூரியன் & சந்திரன்',
      auspicious: 'சுப / அசுப காலங்கள்',
      gowri: 'கௌரி பஞ்சாங்கம்',
      gowriDay: 'பகல்',
      gowriNight: 'இரவு',
    },
    date: {
      today: 'இன்று',
      prevDay: 'முந்தைய நாள்',
      nextDay: 'அடுத்த நாள்',
      openCalendar: 'நாட்காட்டி திற',
    },
    ayanamsa: {
      label: 'அயனாம்சம்',
      lahiri: 'லாஹிரி',
      kp: 'KP (கிருஷ்ணமூர்த்தி)',
      raman: 'ராமன்',
      true_chitra: 'சுத்த சித்ரா',
    },
    nature: {
      auspicious: 'சுபம்',
      inauspicious: 'அசுபம்',
      neutral: 'நடுநிலை',
    },
    periods: {
      rahuKaal: 'ராகு காலம்',
      yamagandam: 'எமகண்டம்',
      gulikai: 'குளிகை',
      nallaNeram: 'நல்ல நேரம்',
      abhijitMuhurta: 'அபிஜித் முஹூர்தம்',
      brahmaMuhurta: 'பிரம்ம முஹூர்தம்',
      amritKalam: 'அமிர்த காலம்',
      durMuhurtam: 'துர் முஹூர்தம்',
      varjyam: 'வர்ஜ்யம்',
    },
    sun: {
      sunrise: 'சூரிய உதயம்',
      sunset: 'சூரிய அஸ்தமனம்',
      moonrise: 'சந்திர உதயம்',
      moonset: 'சந்திர அஸ்தமனம்',
      dinamana: 'தினமானம் (பகல் நீளம்)',
      ratrimana: 'ராத்ரிமானம் (இரவு நீளம்)',
    },
    festival: {
      label: 'திருவிழா',
    },
  },

  // ─── Siddhanta Selector ───
  siddhanta: {
    label: 'சித்தாந்தம்',
    drik: 'திருக்கணிதம்',
    vakyam: 'வாக்கியம்',
    compare: 'இரண்டையும் ஒப்பிடுக',
    badge: {
      drik: 'திருக்கணிதம் (Drik)',
      vakyam: 'வாக்கியம் (Surya Siddhanta)',
    },
    ayanamsaDisabledTooltip: 'வாக்கியம் அதன் பாரம்பரிய சூரிய சித்தாந்த ஆயனம்சத்தைப் பயன்படுத்துகிறது',
  },

  // ─── Drik vs Vakyam Comparison ───
  comparison: {
    agreement: {
      high: 'உயர் ஒப்புதல் \u2014 இரு சித்தாந்தங்களும் நெருக்கமாக பொருந்துகின்றன',
      partial: 'ஒரளவு ஒப்புதல் \u2014 இன்று சில வேறுபாடுகள்',
      low: 'குறைந்த ஒப்புதல் \u2014 இன்று குறிப்பிடத்தக்க வேறுபாடுகள்',
    },
    fields: {
      sunrise: 'சூரிய உதயம்',
      sunset: 'சூரிய அஸ்தமனம்',
      tithi: 'திதி',
      nakshatra: 'நட்சத்திரம்',
      yoga: 'யோகம்',
      karana: 'கரணம்',
      tamil_yogam: 'தமிழ் யோகம்',
      rahu_kaal: 'ராகு காலம்',
    },
    header: {
      drik: 'திருக்கணிதம்',
      vakyam: 'வாக்கியம்',
      delta: 'வேறுபாடு',
    },
    match: {
      yes: 'பெயர்கள் பொருந்துகின்றன',
      no: 'பெயர்கள் வேறுபடுகின்றன',
    },
    festival: {
      both_same_date: 'இரண்டும் ஒப்புக்கொள்கின்றன',
      different_date: 'வேறு தேதிகள்',
      drik_only: 'திருக்கணிதம் மட்டும்',
      vakyam_only: 'வாக்கியம் மட்டும்',
    },
    educational: {
      title: 'ஏன் இவை வேறுபடுகின்றன?',
      body: 'திருக்கணிதம் (Drik Ganita) நவீன வானியல் மாதிரிகளுடன் NASA JPL DE431 இபெமெரிஸைப் பயன்படுத்துகிறது. வாக்கியம் பாரம்பரிய சூரிய சித்தாந்த சூத்திரங்களைப் (~1500 CE) பயன்படுத்துகிறது. இரண்டுமே செல்லுபடியாகும் மரபுகள். காஞ்சிபுரம் மற்றும் ஸ்ரீரங்கத்தில் உள்ள முக்கிய கோயில்கள் வாக்கியத்தைப் பின்பற்றுகின்றன; அச்சிடப்பட்ட பெரும்பாலான தமிழ் பஞ்சாங்கங்கள் திருக்கணிதத்தைப் பயன்படுத்துகின்றன.',
      deltaNote: 'வேறுபாடு = வாக்கியம் \u2212 திருக்கணிதம். நேர்க்குறி எனில் வாக்கியம் பின்னர்.',
    },
    detailed: {
      expand: 'இரு சித்தாந்தங்களுக்கும் முழு பஞ்சாங்கம் காண்க',
      collapse: 'முழு பஞ்சாங்கத்தை மறை',
      drikHeading: 'திருக்கணிதம் (Drik)',
      vakyamHeading: 'வாக்கியம் (Surya Siddhanta)',
    },
  },

  // ─── Rama Shalaka Prashnavali ───
  ramaShalaka: {
    titleEn: 'Sri Rama Shalaka Prashnavali',
    titleTa: 'ஸ்ரீ ராம சலாக பிரஶ்னாவலி',
    invitation: 'உள்ளத்தில் ஒரு கேள்வியைப் பொருத்தி, ஸ்ரீ ராமனின் அருளைக் கேளுங்கள்',
    instruction1: 'கண்களை மூடி உங்கள் கேள்வியில் கவனம் செலுத்துங்கள்',
    instruction2: 'தயாரானதும், கட்டத்தில் எங்கேயும் தொடுங்கள்',
    instruction3: 'எழுத்துக்கள் ஸ்ரீ ராமனின் அருளைக் காட்டும்',
    beginButton: 'தொடங்கு',
    gridTitle: 'ஸ்ரீ ராமனின் அருள்வாக்கு',
    gridPrompt: 'உங்கள் கேள்வியை மனதில் நினைத்து, எந்த கட்டத்தையும் தொடுங்கள்',
    resultHeading: 'ஸ்ரீ ராமனின் அருள்வாக்கு',
    collectedLettersAria: 'பாதையில் சேகரிக்கப்பட்ட எழுத்துக்கள்',
    meaningHeading: 'பொருள்',
    shareButton: 'பகிரு',
    returnButton: 'திரும்பு',
    cooldownMessage: 'பாரம்பரியம்படி, ஒவ்வொரு கேள்விக்கும் ஒரு மணி நேரம் தியானிக்க வேண்டும்',
    cooldownRemaining: 'அடுத்த கேள்வி {n} நிமிடங்களில்',
    cooldownLessThanMinute: 'அடுத்த கேள்வி ஒரு நிமிடத்திற்குள்',
    viewLastReading: 'கடந்த வாசிப்பைப் பார்க்கவும்',
    aboutToggleClosed: 'ராம சலாக பிரஶ்னாவலி என்றால் என்ன?',
    aboutToggleOpen: 'மூடு',
    aboutOrigin: 'இந்த கருவி ஸ்ரீ துளசிதாஸின் ராமசரிதமானஸத்தை (~1574 CE) அடிப்படையாகக் கொண்டது.',
    aboutHow: '81 எழுத்துக்கள் 9×9 கட்டத்தில் அமைக்கப்பட்டுள்ளன. ஒவ்வொரு கட்டமும் 9-எழுத்து பாதையின் தொடக்கம்; அது காவியத்தின் ஒரு செய்யுளை உருவாக்கும்.',
    aboutIntention: 'மனதில் ஒரு கேள்வியை வைத்து, ஒரு கட்டத்தைத் தேர்ந்தெடுங்கள்; செய்யுள் உங்கள் வழிகாட்டியாக கிடைக்கும்.',
    aboutCulture: 'இந்த பாரம்பரியம் கோயில்களிலும் வீடுகளிலும் இந்தியா முழுவதும் ஆன்மீக ஆலோசனையாக பின்பற்றப்படுகிறது.',
    shareTitle: 'ஸ்ரீ ராமனின் அருள்வாக்கு',
    shareAlt: 'பகிர்வு அட்டை முன்னோட்டம்',
    rendering: 'உங்கள் வாசிப்பு தயாராகிறது...',
    shareError: 'படத்தை உருவாக்க முடியவில்லை',
    shareNative: 'பகிரு',
    shareSave: 'சாதனத்தில் சேமி',
    shareClose: 'மூடு',
    tileTitle: 'ராம சலாகா',
    tileDesc: 'ஸ்ரீ ராமனிடம் ஒரு கேள்வி கேளுங்கள் — 9×9 கட்டம்',
    tileCategory: 'தெய்வ பிரஶ்னாவலி',
  },

  // ─── Ganesha Prashnavali ───
  ganeshaPrashnavali: {
    titleEn: 'Sri Ganesha Prashnavali',
    titleTa: 'ஸ்ரீ கணேஷ பிரஶ்னாவலி',
    invitation: 'உள்ளத்தில் ஒரு முடிவை நினைத்து, கணபதியின் வழிகாட்டலைக் கேளுங்கள்',
    instruction1: 'உங்கள் கேள்வியை நேர்மையாக நினையுங்கள்',
    instruction2: '8×8 கட்டத்தில் எந்தவொரு செல்லையும் தொடுங்கள்',
    instruction3: 'கணபதி உங்கள் பதிலை வெளிப்படுத்துவார்',
    beginButton: 'தொடங்கு',
    gridTitle: 'ஸ்ரீ கணேஷனின் அருள்வாக்கு',
    gridPrompt: 'உங்கள் கேள்வியை மனதில் நினைத்து, எந்தவொரு செல்லையும் தொடுங்கள்',
    resultHeading: 'ஸ்ரீ கணேஷனின் அருள்வாக்கு',
    interpretationHeading: 'கணேஷனின் செய்தி',
    cellLabelEn: 'Cell {n}',
    cellLabelTa: 'கட்டம் {n}',
    remedyHeading: 'பரிகாரம்',
    shareButton: 'பகிரு',
    returnButton: 'திரும்பு',
    cooldownMessage: 'பாரம்பரியம்படி, ஒவ்வொரு கேள்விக்கும் ஒரு மணி நேரம் தியானிக்க வேண்டும்',
    cooldownRemaining: 'அடுத்த கேள்வி {n} நிமிடங்களில்',
    cooldownLessThanMinute: 'அடுத்த கேள்வி ஒரு நிமிடத்திற்குள்',
    viewLastReading: 'கடந்த வாசிப்பைப் பார்க்கவும்',
    aboutToggleClosed: 'கணேஷ பிரஶ்னாவலி என்றால் என்ன?',
    aboutToggleOpen: 'மூடு',
    aboutOrigin: 'இந்த கருவி கணேஷ புராணத்தின் 64 கட்டங்கள் மூலமான ஜோதிட பாரம்பரியத்தை அடிப்படையாகக் கொண்டது.',
    aboutHow: '64 கட்டங்கள் 8×8 கட்டமாக அமைக்கப்பட்டுள்ளன. ஒவ்வொரு கட்டமும் ஒரு செய்யுள், விளக்கம், மற்றும் சாதகத்தன்மை நிலையுடன் கூடிய ஒரு குறிப்பிட்ட அறிவிப்புடன் இணைக்கப்பட்டுள்ளது.',
    aboutIntention: 'மனதில் ஒரு முடிவை வைத்து, ஒரு கட்டத்தைத் தொடுங்கள்; கணபதியின் வழிகாட்டல் கிடைக்கும்.',
    aboutCulture: 'ஆம்/இல்லை முடிவுகளுக்கு ஆன்மீக ஆலோசனையாக தமிழ் கோயில்களில் பயன்படுத்தப்படுகிறது.',
    auspiciousness: {
      highlyFavorable: 'மிகவும் சாதகம்',
      favorable: 'சாதகம்',
      neutral: 'நடுநிலை',
      cautionary: 'எச்சரிக்கை',
      unfavorable: 'சாதகமற்றது',
      aria: 'சாதகத்தன்மை: {label}, 5 இல் {n} நிலை',
    },
    shareTitle: 'ஸ்ரீ கணேஷனின் அருள்வாக்கு',
    shareAlt: 'பகிர்வு அட்டை முன்னோட்டம்',
    rendering: 'உங்கள் வாசிப்பு தயாராகிறது...',
    shareError: 'படத்தை உருவாக்க முடியவில்லை',
    shareNative: 'பகிரு',
    shareSave: 'சாதனத்தில் சேமி',
    shareClose: 'மூடு',
    tileTitle: 'கணேஷ பிரஶ்னாவலி',
    tileDesc: 'கணபதியிடம் வழிகாட்டல் கேளுங்கள் — 8×8 சாதகத்தன்மை கட்டம்',
    tileCategory: 'தெய்வ பிரஶ்னாவலி',
  },

  // ─── Prashnavali shared (share modal) ───
  prashnavali: {
    share: {
      rendering: 'உங்கள் வாசிப்பு தயாராகிறது...',
      error: 'படத்தை உருவாக்க முடியவில்லை',
      alt: 'பகிர்வு அட்டை முன்னோட்டம்',
      shareNative: 'பகிரு',
      save: 'சாதனத்தில் சேமி',
      close: 'மூடு',
    },
    panchangam: {
      insightHeading: 'பஞ்சாங்க நுண்ணறிவு',
      snapshotHeading: 'பிரபஞ்ச தருணம்',
      nakshatra: 'நட்சத்திரம்',
      tithi: 'திதி',
      hora: 'ஹோரை',
      horaSuffix: 'ஹோரை',
      tamilYogam: 'தமிழ் யோகம்',
      activePeriod: 'நடப்பு காலம்',
      muhurtaGreen: 'கேள்விக்கு உகந்த நேரம்',
      muhurtaYellow: 'நடுநிலை நேரம்',
      muhurtaRed: 'சற்று பொறுத்து கேட்கலாம்',
      muhurtaLoading: 'தருணத்தை வாசிக்கிறது...',
      pakshaShukla: 'சுக்ல',
      pakshaKrishna: 'கிருஷ்ண',
      pakshaSeparator: 'பக்ஷ',
      activePeriodNallaNeram: 'நல்ல நேரம்',
      activePeriodRahuKaal: 'ராகு காலம்',
      activePeriodYamagandam: 'யமகண்டம்',
      activePeriodGulikai: 'குளிகை',
      activePeriodVarjyam: 'வர்ஜ்யம்',
      activePeriodBhadra: 'பத்ரா',
      activePeriodPanchaka: 'பஞ்சகம்',
      activePeriodSarvarthaSiddhi: 'சர்வார்த்த சித்தி',
      activePeriodAmritSiddhi: 'அமிர்த சித்தி',
      activePeriodNone: 'எதுவும் செயலில் இல்லை',
      badgeAriaGreen: 'பஞ்சாங்க முகூர்த்தம்: பச்சை, உகந்த நேரம்',
      badgeAriaYellow: 'பஞ்சாங்க முகூர்த்தம்: மஞ்சள், நடுநிலை',
      badgeAriaRed: 'பஞ்சாங்க முகூர்த்தம்: சிவப்பு, கவனம்',
    },
  },

  // ─── Hanuman Prashnavali ───
  hanumanPrashnavali: {
    titleEn: 'Sri Hanuman Prashnavali',
    titleTa: 'ஸ்ரீ ஆஞ்சநேய பிரஶ்னாவலி',
    invitation: 'உங்கள் சவாலை உள்ளத்தில் நினைத்து, ஆஞ்சநேயரின் ஆலோசனையைக் கேளுங்கள்',
    instruction1: 'நீங்கள் எதிர்கொள்ளும் சவாலை நினையுங்கள்',
    instruction2: '7×7 கட்டத்தில் எந்தவொரு செல்லையும் தொடுங்கள்',
    instruction3: 'ஆஞ்சநேயர் தைரியத்திற்கான ஆலோசனையை அளிப்பார்',
    beginButton: 'தொடங்கு',
    gridTitle: 'ஆஞ்சநேயரின் ஆலோசனை',
    gridPrompt: 'உங்கள் கேள்வியை மனதில் நினைத்து, எந்தவொரு செல்லையும் தொடுங்கள்',
    resultHeading: 'ஆஞ்சநேயரின் ஆலோசனை',
    collectedLettersAria: 'பாதையில் சேகரிக்கப்பட்ட எழுத்துக்கள்',
    interpretationHeading: 'ஆலோசனை',
    chalisaLineAttribution: 'ஹனுமான் சாலீஸா — வரி {n}',
    shareButton: 'பகிரு',
    returnButton: 'திரும்பு',
    shareTitle: 'ஆஞ்சநேயரின் ஆலோசனை',
    cooldownMessage: 'பாரம்பரியம்படி, ஒவ்வொரு கேள்விக்கும் ஒரு மணி நேரம் தியானிக்க வேண்டும்',
    cooldownRemaining: 'அடுத்த கேள்வி {n} நிமிடங்களில்',
    cooldownLessThanMinute: 'அடுத்த கேள்வி ஒரு நிமிடத்திற்குள்',
    viewLastReading: 'கடந்த வாசிப்பைப் பார்க்கவும்',
    specialDayLanding: 'இன்று ஆஞ்சநேயர் நாள் — ஆசீர்வாதம் விசேஷமாகும்',
    specialDayResult: 'ஆஞ்சநேயர் நாள் வாசிப்பு',
    aboutToggleClosed: 'ஆஞ்சநேய பிரஶ்னாவலி என்றால் என்ன?',
    aboutToggleOpen: 'மூடு',
    aboutOrigin: 'இந்த கருவி ஸ்ரீ துளசிதாஸ் இயற்றிய ஹனுமான் சாலீஸாவை அடிப்படையாகக் கொண்டது.',
    aboutHow: '49 செல்கள் 7×7 கட்டமாக அமைக்கப்பட்டுள்ளன. ஒவ்வொரு செல்லும் 7 எழுத்து பாதையின் தொடக்கம்; அது சாலீஸாவின் ஒரு வரியை வெளிப்படுத்தும்.',
    aboutIntention: 'உங்கள் சவாலை மனதில் நினைத்து, ஒரு செல்லைத் தேர்ந்தெடுத்து ஆஞ்சநேயரின் ஆலோசனையைப் பெறுங்கள்.',
    aboutCulture: 'செவ்வாய் மற்றும் சனிக்கிழமைகள் ஆஞ்சநேயருக்கு பாரம்பரியமாக அர்ப்பணிக்கப்பட்டவை. இந்த நாட்களில் பக்தர்கள் சவால்களுக்கான வலிமையைத் தேடுகிறார்கள்.',
    tileTitle: 'ஆஞ்சநேய பிரஶ்னாவலி',
    tileDesc: 'ஆஞ்சநேயரின் ஆலோசனையைக் கேளுங்கள் — 7×7 ஹனுமான் சாலீஸா பாதை',
    tileCategory: 'தெய்வ பிரஶ்னாவலி',
  },

  // ─── Chanakya Niti ───
  chanakyaNiti: {
    titleEn: 'Chanakya Niti Prashnavali',
    titleTa: 'சாணக்ய நீதி பிரஶ்னாவலி',
    invitation: 'யுத்தி, ஆட்சி அல்லது உறவுகள் பற்றிய கேள்வியை மனதில் நினையுங்கள்.',
    instruction1: 'உங்கள் கேள்வியை கவனமாக பரிசீலனை செய்யுங்கள்',
    instruction2: '6×6 கட்டத்தில் எந்தவொரு செல்லையும் தொடுங்கள்',
    instruction3: 'சாணக்கியரின் சூத்திரம் ஆலோசனை அளிக்கும்',
    consultButton: 'ஆலோசிக்கவும்',
    gridTitle: 'ஒரு சூத்திரத்தைத் தேர்ந்தெடுக்கவும்',
    gridPrompt: 'உங்கள் கேள்வியை பரிசீலனை செய்து, எந்தவொரு செல்லையும் தொடுங்கள்',
    resultHeading: 'சாணக்கியரின் ஆலோசனை',
    aphorismNumber: 'சூத்திரம் {n}',
    interpretationHeading: 'பொருள்',
    shareButton: 'பகிரு',
    returnButton: 'திரும்பு',
    shareTitle: 'சாணக்கியரின் ஆலோசனை',
    cooldownMessage: 'பாரம்பரியம்படி, மீண்டும் ஆலோசிக்க முன் ஒரு மணி நேரம் சாணக்கியரின் ஆலோசனையை பிரதிபலிக்க வேண்டும்.',
    cooldownRemaining: 'அடுத்த ஆலோசனை {n} நிமிடங்களில்',
    cooldownLessThanMinute: 'அடுத்த ஆலோசனை ஒரு நிமிடத்திற்குள்',
    viewLastReading: 'உங்கள் கடந்த சூத்திரத்தைப் பார்க்கவும்',
    aboutToggleClosed: 'சாணக்கியர் யார்?',
    aboutToggleOpen: 'மூடு',
    aboutWho: 'சாணக்கியர் (கௌடில்யர்) பழங்கால இந்திய அறிஞர், சந்திரகுப்த மௌரியரின் ஆலோசகர் (~கி.மு. 300), அர்த்தசாஸ்திரம் மற்றும் நீதி சாஸ்திரத்தின் ஆசிரியர்.',
    aboutText: 'நீதி சாஸ்திரம் ஆட்சி, யுத்தி, உறவுகள் மற்றும் நீதி குறித்த சூத்திரங்களின் தொகுப்பாகும்.',
    aboutHow: '36 சூத்திரங்கள் 6×6 கட்டமாக அமைக்கப்பட்டுள்ளன. ஒவ்வொரு செல்லும் ஒரு கருப்பொருள் குறியிடப்பட்ட ஒரு சூத்திரத்துடன் இணைக்கப்பட்டுள்ளது.',
    aboutIntention: 'முடிவுகள், யுத்தி அல்லது உறவுகள் குறித்த கண்ணோட்டத்திற்காக ஆலோசனை கேளுங்கள். பாரம்பரிய ஞானத்தின் பிரதிபலிப்பு.',
    themes: {
      business: 'வணிகம்',
      relationships: 'உறவுகள்',
      governance: 'ஆட்சி',
      self_discipline: 'சுய ஒழுக்கம்',
      strategy: 'யுத்தி',
      ethics: 'நீதி',
    },
    themeAriaLabel: 'கருப்பொருள்: {theme}, சூத்திரம் {n}',
    tileTitle: 'சாணக்ய நீதி',
    tileDesc: 'சாணக்கியரின் யுத்தி மற்றும் நீதி சூத்திரங்களை ஆலோசிக்கவும் — 6×6 நீதி சாஸ்திரம்',
    tileCategory: 'தெய்வ பிரஶ்னாவலி',
  },
};

export default ta;
